import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-groups-empty-state-cta',
  template: ` <ng-content></ng-content> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupsGenericEmptyStateCTAComponent {}

@Component({
  standalone: false,
  selector: 'app-groups-generic-empty-state',
  template: `
    <fl-picture
      [src]="imgSrc"
      [alt]="imgAlt"
    ></fl-picture>

    @if (oneLineMessage) {
      <p class="text-center">
        {{ primaryMessage }}
        @if (secondaryMessage) {
          <span class="text-foreground text-body-16 font-bold">
            {{ secondaryMessage }}
          </span>
        }
      </p>
    } @else {
      <p class="text-center">
        {{ primaryMessage }}
      </p>
      @if (secondaryMessage) {
        <p class="text-center font-bold">
          {{ secondaryMessage }}
        </p>
      }
    }

    <ng-content select="app-groups-empty-state-cta"></ng-content>
  `,
  styleUrls: ['./groups-generic-empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupsGenericEmptyStateComponent {
  @Input() imgSrc: string;
  @Input() imgAlt: string;
  @Input() oneLineMessage = false;
  @Input() primaryMessage: string;
  @Input() secondaryMessage?: string;
}
